import $ from 'jquery';
import cart from '@wc-stripe/cart';
import AbstractMessage from './AbstractMessage';

class ShopMessage extends AbstractMessage {

    data = {};

    constructor(props) {
        super(props);
        this.data = props.data;
    }

    showMessageElement() {
        $(this.selector).show();
    }

    getTotalCents() {
        return this.data.priceCents;
    }

    getCurrency() {
        return cart.getCurrency();
    }
}

export default ShopMessage;